module.exports = __webpack_public_path__ + "images/exterior-3d-3-47b508bc697858c366965b9ab48d1a44.jpg";